import axios from 'axios'

// 初始化DeepPay在线支付
const initOnlinePayment = form =>
  axios.post('/api/v1/payments/init-online-pay', form).then(res => res.data)

// 初始化支付信息（旧接口保留）
const initPayment = form =>
  axios.post('/api/v1/payments', form).then(res => res.data)

export { initPayment, initOnlinePayment }
